import React from 'react'
import cx from 'classnames'

export default function Container ({ className = '', ...props }) {
  return (
    <div className={cx('max-w-1120 mx-auto px-16', className)} {...props} />
  )
}
